export const translate = (en, pl) => en;

export const translateDynamic = i18n => (en, pl) => (i18n.language === 'en' ? en : pl);
